import { Box } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputForm from "../forms/inputForm";
import SelectForm from "../forms/selectFormm";
import { useAppDispatch } from "../../../store";
import { useEffect, useState } from "react";
import useDebouncedEffect from "../../../hooks/useDebouncedEffect";
import DatePickerForm from "../forms/datePickerForm";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import { setPageKey } from "../../../store/feature/reducers/roleReducer";

const schema = yup.object({
  title: yup.string().required(),
});

const DddFieldsSearch = ({ params, setParams }: any) => {
  const [searchFilterDebounced, setSearchFilterDebounced] = useState("");
  const [name, setName] = useState("");
  const [specVer, setSpecVer] = useState("");
  const [dauri, setDauri] = useState("");
  const [enrolledStart, setEnrolledStart] = useState("");
  const [enrolledEnd, setEnrolledEnd] = useState("");
  const [userActive, setUserActive] = useState(""); // TODO: NEED PARAMETER FROM API
  const dispatch = useAppDispatch();

  const {
    control,
    reset,
    formState: { errors },
  } = useForm<{
    name: string;
    dauri: string;
    specVer: string;
    enrolledStart: string;
    enrolledEnd: string;
  }>({
    reValidateMode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: {
      name: "",
      dauri: "",
      specVer: "",
      enrolledStart: "",
      enrolledEnd: "",
    },
  });

  const specVerDropdown = [
    {
      label: "ISO/IEC 20248:2022",
      value: "ISO/IEC 20248:2022",
    },
  ];

  const handleName = (e: string) => {
    setName(e);
  };
  const handleDauri = (e: string) => {
    setDauri(e);
  };
  const handleSpecVer = (e: any) => {
    // setSpecVer(e.value);
    console.log("haha ===> ", e);
    if (e !== null) {
      setSpecVer(e.value);
    } else {
      setSpecVer("");
    }
  };
  // const handleStatusSelect = (e: any) => { setUserActive(e.value); };
  const handleEnrolledStart = (e: any) => {
    let NewDate: any;
    if (e !== null) {
      NewDate = dayjs(e).format("YYYY-MM-DD");
      if (dayjs(e).isAfter(dayjs(enrolledEnd))) {
        setAllDate(NewDate);
      } else {
        setEnrolledStart(NewDate);
      }
    } else {
      NewDate = "";
      setAllDate(NewDate);
    }
  };
  const setAllDate = (date: string) => {
    reset({
      // deviceId: deviceId,
      // hostname: hostname,
      // enrolledStart: date,
      // enrolledEnd: date,
      // status: userActive,
      name,
      dauri,
      specVer,
      enrolledStart: date,
      enrolledEnd: date,
    });
    setEnrolledStart(date);
    setEnrolledEnd(date);
  };
  const handleEnrolledEnd = (e: any) => {
    let NewDate: any;
    if (e !== null) {
      NewDate = dayjs(e).format("YYYY-MM-DD");
    } else {
      NewDate = "";
    }
    if (conditionCheck()) setEnrolledEnd(NewDate);
  };
  const conditionCheck = () => {
    if (enrolledStart === "") {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        showCancelButton: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#051438",
        text: "Please select Start Created",
      });
      reset({
        // deviceId: deviceId,
        // hostname: hostname,
        // enrolledStart: "",
        // enrolledEnd: "",
        // status: userActive,
        name,
        dauri,
        specVer,
        enrolledStart: "",
        enrolledEnd: "",
      });
      setEnrolledEnd("");
      return false;
    } else {
      return true;
    }
  };

  useDebouncedEffect(() => setSearchFilterDebounced(name), [name], 500);
  useDebouncedEffect(() => setSearchFilterDebounced(dauri), [dauri], 500);
  useDebouncedEffect(() => setSearchFilterDebounced(specVer), [specVer], 500);
  useDebouncedEffect(
    () => setSearchFilterDebounced(userActive),
    [userActive],
    500
  );
  useDebouncedEffect(
    () => setSearchFilterDebounced(enrolledStart),
    [enrolledStart],
    500
  );
  useDebouncedEffect(
    () => setSearchFilterDebounced(enrolledEnd),
    [enrolledEnd],
    500
  );

  useEffect(() => {
    setParams({
      ...params,
      name: name,
      daUri: dauri,
      specVersion: specVer,
      createdFrom: enrolledStart,
      createdTo: enrolledEnd,
      // param_filter_status: userActive,
    });
    dispatch(setPageKey(name || dauri || specVer || enrolledStart || enrolledEnd));
  }, [searchFilterDebounced]);

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "row", gap: "1rem", flex: 1 }}>
        <InputForm
          name="name"
          errors={errors}
          control={control}
          required
          placeholder="Name"
          maxLength={100}
          isLoading={false}
          onChange={handleName}
        />
        <SelectForm
          name="specVer"
          defaultValue={1}
          options={specVerDropdown}
          placeholder="Specification Version"
          disabled={false}
          isLoading={false}
          control={control}
          errors={errors}
          required
          sxFL={{ backgroundColor: "red" }}
          onChangeForm={handleSpecVer}
          isClear
        />
        <InputForm
          name="dauri"
          errors={errors}
          control={control}
          required
          placeholder="Dauri"
          maxLength={100}
          isLoading={false}
          onChange={handleDauri}
        />
        <DatePickerForm
          name="enrolledStart"
          defaultValue={null}
          control={control}
          errors={errors}
          placeholder="Start Created"
          disabled={false}
          isLoading={false}
          required
          onChange={handleEnrolledStart}
        />
        <DatePickerForm
          name="enrolledEnd"
          defaultValue={null}
          control={control}
          errors={errors}
          placeholder="End Created"
          disabled={false}
          isLoading={false}
          required
          onChange={handleEnrolledEnd}
        />
      </Box>
    </Box>
  );
};

export default DddFieldsSearch;
